import { render, staticRenderFns } from "./ServicoDigitalList.vue?vue&type=template&id=24fa79b0&lang=true"
import script from "./ServicoDigitalList.vue?vue&type=script&lang=js"
export * from "./ServicoDigitalList.vue?vue&type=script&lang=js"
import style0 from "./ServicoDigitalList.vue?vue&type=style&index=0&id=24fa79b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports